module.exports = function() {
  return new Worker(__webpack_public_path__ + "776828455bf8370cd05f.worker.js");
};